import i18n from '@/i18n.js'
import { getActiveLayoutColors } from '@/composables/globalData/useLayouts'

const { inCall, onHold } = getActiveLayoutColors()

export const VOICEBOT_COUNTER_TYPES = {
    COUNTER: 'counter',
    WAIT_TIME: 'waitTime',
} as const

type VoicebotCounterKind = typeof VOICEBOT_COUNTER_TYPES[keyof typeof VOICEBOT_COUNTER_TYPES]

type VoicebotTypeConfig = {
    id: number
    icon: string
    type: VoicebotCounterKind
    color: string
    text: string
}

export const VOICEBOT_ACTIVE_CALLS_CONFIG = {
    id: 0,
    icon: 'Bot',
    type: VOICEBOT_COUNTER_TYPES.COUNTER,
    color: inCall,
    text: 'voicebot.counter.activeCalls'
} as const

export const VOICEBOT_AVERAGE_CALL_TIME_CONFIG = {
    id: 1,
    icon: 'Clock',
    type: VOICEBOT_COUNTER_TYPES.WAIT_TIME,
    color: onHold,
    text: 'voicebot.counter.averageCallTime'
} as const

export const VOICEBOT_MAX_CALL_TIME_CONFIG = {
    id: 2,
    icon: 'CalendarClock',
    type: VOICEBOT_COUNTER_TYPES.WAIT_TIME,
    color: onHold,
    text: 'voicebot.counter.maxCallTime'
} as const

export const voicebotTypesList = [
    VOICEBOT_ACTIVE_CALLS_CONFIG,
    VOICEBOT_AVERAGE_CALL_TIME_CONFIG,
    VOICEBOT_MAX_CALL_TIME_CONFIG
] as const satisfies readonly VoicebotTypeConfig[]

export type VoicebotTypeId = typeof voicebotTypesList[number]['id']
export type VoicebotCounterTypeId = Extract<
    typeof voicebotTypesList[number],
    { type: typeof VOICEBOT_COUNTER_TYPES.COUNTER }
>['id']

const VOICEBOT_COUNTER_TYPE_ID_SET: ReadonlySet<number> = new Set<number>(
    voicebotTypesList.filter(t => t.type === VOICEBOT_COUNTER_TYPES.COUNTER).map(t => t.id)
)

export const voicebotTypes = Object.fromEntries(
    voicebotTypesList.map(el => {
        return [
            el.id,
            el
        ]
    })
)

export function isVoicebotCounter (type: number): type is VoicebotCounterTypeId {
    return VOICEBOT_COUNTER_TYPE_ID_SET.has(type)
}

export function voicebotTypeNamesMapped () {
    return voicebotTypesList.map((item) => {
        return {
            value: item.id,
            label: i18n.t(item.text)
        }
    })
}


